import { Component, Inject, Injectable, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';

@Component({
    selector: 'app-confirm-delete-alert',
    templateUrl: './confirm-delete-alert.component.html',
    styleUrls: ['./confirm-delete-alert.component.scss'],
    standalone: false
})

export class ConfirmDeleteAlertComponent implements OnInit {

    constructor(private alertController: AlertController, public manager: ModulesManagerService) { }
    private alert: any = null
    ngOnInit() { }

    get alertIsPresent() { 
        return this.alert != null && this.alert != undefined && this.alert.isPresent();
    }
    
    async presentAlert(options) {
        if(this.alertIsPresent) return
        this.alert = await this.alertController.create(options);
        this.alert.onDidDismiss().then(() => {
            this.alert = null
        })
        await this.alert.present();
    }

    async dismissAlert() {
        if(this.alert) await this.alert.dismiss();
        this.alert = null
    }
}
